import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { categories } from '@/utils/articles';
import SearchBox from './SearchBox';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category/entertainment', label: '娱乐黑料' },
  { to: '/category/star', label: '明星爆料' },
  { to: '/category/society', label: '社会热点' },
  { to: '/hot', label: '热门排行' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* utility strip */}
      <div className="hidden bg-foreground-950 text-background-100 md:block">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between px-4 text-xs md:px-6">
          <div className="flex items-center gap-2 text-background-300">
            <i className="ri-flashlight-fill text-primary-400"></i>
            <span>24小时滚动更新 · 最新黑料第一时间送达</span>
          </div>
          <div className="flex items-center gap-4 text-background-300">
            <Link to="/hot" className="cursor-pointer transition-colors hover:text-primary-400">
              今日热搜榜
            </Link>
            <span className="text-background-700">|</span>
            <Link to="/tags/顶流塌房" className="cursor-pointer transition-colors hover:text-primary-400">
              塌房预警专题
            </Link>
          </div>
        </div>
      </div>

      {/* main nav */}
      <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-6 px-4 md:px-6">
          <Link to="/" className="flex shrink-0 cursor-pointer items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-alarm-warning-fill text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-lg font-black tracking-tight text-foreground-950">
                91黑料网
              </span>
              <span className="font-label text-[10px] uppercase tracking-widest text-primary-600">
                Hot Leaks 24H
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto hidden w-72 xl:block">
            <SearchBox />
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {/* mobile drawer */}
      {menuOpen && (
        <div className="fixed inset-0 top-16 z-40 animate-fade-in bg-background-50 lg:hidden">
          <div className="flex h-full flex-col overflow-y-auto px-4 py-4">
            <SearchBox variant="mobile" onNavigate={() => setMenuOpen(false)} />
            <nav className="mt-4 flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) =>
                    `flex items-center justify-between border-b border-background-200 px-1 py-3 text-base font-medium ${
                      isActive ? 'text-primary-600' : 'text-foreground-800'
                    }`
                  }
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </NavLink>
              ))}
            </nav>
            <div className="mt-5">
              <p className="mb-2 text-xs font-semibold text-foreground-500">热门分类</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="flex cursor-pointer items-center gap-1 rounded-full bg-secondary-100 px-3 py-1.5 text-sm text-secondary-900"
                  >
                    <i className={c.icon}></i>
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}